import { render, staticRenderFns } from "./SettingsLimits.vue?vue&type=template&id=06cf7294&"
import script from "./SettingsLimits.vue?vue&type=script&lang=js&"
export * from "./SettingsLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports